import { Component } from "../../../components/base/Component";
import { ICfa } from "../../../models/ICfa";
import { ComponentFactory } from "../../../services/ComponentFactory";

function extractTemplate(context: HTMLElement, selector: string): string {
	const template = context.querySelector<HTMLTemplateElement>(selector);
	const html = template?.innerHTML ?? "";
	template?.parentElement?.removeChild(template);

	return html;
}

export class SimpleCarousel extends Component {
	public readonly carouselEl: JQuery;
	public carousel: JQuery | null = null;

	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);
		this.carouselEl = $(_element);

		this.initCarousel();
	}

	initCarousel(): void {
		const carouselOptions: JQuerySlickOptions = {
			accessibility: false,
			cssEase: "linear",
			dots: false,
			fade: false,
			infinite: true,
			mobileFirst: true,
			nextArrow: extractTemplate(this._element, "template[data-next-arrow]"),
			prevArrow: extractTemplate(this._element, "template[data-prev-arrow]"),
			slidesToShow: 1,
			speed: 500,
			useTransform: false
		};

		if ($(".panel-btn").length > 0) {
			$(".panel-btn").on("click", () => {
				$(window).trigger("resize");
				this.carouselEl.slick("slickGoTo", 0);
				this.carouselEl.slick("setPosition");
			});
		}

		this.carousel = this.carouselEl.slick(carouselOptions);
	}
}

ComponentFactory.registerComponent("SimpleCarousel", SimpleCarousel);
